<template>
    <div>
        <div class="container bg-light py-4">
            <div class="conoce-avance-vendedores">
                <h5>Conoce tu avance</h5>
                <p>Aquí podrás ver el avance de tus variables y las de tus colaboradores del mes seleccionado.</p>
            </div>
        </div>

        <div class="container-fluid px-md-3 px-lg-5 px-sm-0 bg-white pt-4">
            <div class="row mb-3 px-3">
                <!-- <div class="col-12 col-md-5 col-lg-4 bg-white rounded-4 shadow p-2"> -->
                <div v-if="client_segment !== 14" class="bg-white rounded-4 shadow p-2 custom-margin" style="max-width: 350px;">
                    <div class="row">
                        <div class="col-4 d-flex justify-content-center align-items-center pe-0 progress-working-days">
                            <el-progress type="circle"
                            class="fw-bold"
                            :percentage="Math.round(Number(advanceWorkingDays) * 10000) / 100"
                            :width="60"
                            :stroke-width="5"
                            :color="customColorWorkDays"
                            >
                            </el-progress>
                        </div>
                        <div class="col-8 d-flex justify-content-center align-items-center ps-0">
                            <p class="mb-0">Este es el % al que deberías ir en tus cumplimientos a la fecha de hoy.</p>
                        </div>
                    </div>
                </div>
                <div v-if="client_segment === 14" class="col-12 col-md-6">
                    <div  class="bg-white rounded-4 shadow p-2 custom-margin">
                        <div class="row">
                            <div class="col-4 d-flex justify-content-center align-items-center pe-0 progress-working-days">
                                <el-progress type="circle"
                                             class="fw-bold"
                                             :percentage="Math.round(Number(advanceWorkingDays) * 10000) / 100"
                                             :width="60"
                                             :stroke-width="5"
                                             :color="customColorWorkDays"
                                >
                                </el-progress>
                            </div>
                            <div class="col-8 d-flex justify-content-center align-items-center ps-0">
                                <p class="mb-0">Este es el % al que deberías ir en tus cumplimientos a la fecha de hoy.</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div v-if="client_segment === 14" class="col-12 col-md-6 text-center text-md-end custom-margin-staff">
                    <a href="/get-pdvs-request-manager" class="text-decoration-none">
                        <button class="btn-request-manager position-relative rounded-3 bg-transparent p-2 px-1 my-3 text-bat align-items-center border border-gray  text-decoration-none text-secondary  text-center aling-items-center border border-secondary justify-content-center py-2">
                            <div class="position-relative d-inline-block me-1">
                                <img src="/img-version2/icons/staff/profile-2user.svg" alt="Progreso">
                                <span v-if="showRedDotRequest >= 1" class="position-absolute top-0 start-100 translate-middle rounded-circle bg-danger fs-8" style="width: 10px; height: 10px;">
                                </span>
                            </div>
                            <span class="me-1 text-title-bat">Ver solicitudes de Staff</span>
                            <span class="ms-1"> ></span>
                        </button>
                    </a>
                </div>
                <span class="nav-text d-flex custom-margin">
                    Navega entre las pestañas para conocer tu avance en los siguientes bloques.
                </span>
            </div>
            <div class="row tabs-gerentes custom-margin">
                <div class=" col-12 col-sm-12 col-md-6">
                    <div class="tabs shadow">
                        <ul class="nav nav-pills mb-3" id="pills-tab" role="tablist">
                            <li class="nav-item" role="presentation">
                                <button class="nav-link active" id="pills-home-tab" data-bs-toggle="pill" data-bs-target="#pills-datos" type="button" role="tab" aria-controls="pills-datos" aria-selected="true">Mis datos</button>
                            </li>
                            <li class="nav-item" role="presentation">
                                <button class="nav-link" id="pills-profile-tab" data-bs-toggle="pill" data-bs-target="#pills-ruta" type="button" role="tab" aria-controls="pills-ruta" aria-selected="false">Buscar por ruta</button>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>

            <div class="container-fluid px-md-3 px-lg-5 px-sm-0 bg-white pb-5 ">
                <div class="tab-content" id="pills-tabContent">
                    <div class="tab-pane fade show active" id="pills-datos" role="tabpanel" aria-labelledby="pills-home-tab" tabindex="0">
<!--                        Pestaña Mis Datos -->
                        <compliance-home
                            :identification="identification"
                            :month="month"
                            :year="year"
                            :hidden_title="true"
                            :hidden_rent="true"
                            :segment_display_rv="segment_display_rv"
                            :accelerators="accelerators"
                            :payments_rv="payments_rv"
                        ></compliance-home>
                    </div>
                    <div class="tab-pane fade" id="pills-ruta"  role="tabpanel" aria-labelledby="pills-profile-tab" tabindex="0">
<!--                        Pestaña Por Ruta-->
                        <div class="row">
                            <div class="col-sm-12 col-lg-6">
                                Aqui puedes ver la información de tu equipo, puedes verla por ruta.
                            </div>
                            <div class="col-sm-12 col-lg-6">
                                <div class="select-sellers">
                                    <select v-model="selected_seller" @change="changeSeller" class="w-full options-sellers">
                                        <option
                                            v-for="secondary_seller in secondary_sellers"
                                            :value="secondary_seller.sales_rep_id"
                                        >
                                            {{ secondary_seller.sales_rep_code }} - {{ secondary_seller.sales_rep_name }}
                                        </option>
                                    </select>
                                </div>
                            </div>
                        </div>

                        <div v-if="secondary_sellers.length === 0" class="py-5 text-center">
                            <h3 class="text-info">Aun no tienes rutas asociadas</h3>
                        </div>
                        <div v-else-if="identification_seller === null" class="py-5 text-center">
                            <h3 class="text-info">Por favor selecciona una ruta para ver sus objetivos</h3>
                        </div>
                        <div v-else>
                            <compliance-home
                                :identification="selected_seller"
                                :month="local_month"
                                :year="local_year"
                                :hidden_simulator="true"
                                :hidden_title="true"
                                :hidden_rent="client_segment === 16 || client_segment === 17 ? true : false"
                                :segment_display_rv="{ ...segment_display_rv, active: 1 }"
                                :accelerators="accelerators"
                                :payments_rv="payments_rv"
                            ></compliance-home>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        identification: {
            default: null,
        },
        month: {
            default: null,
        },
        year: {
            default: null,
        },
        client_segment: {
            default: 14,
        },
        segment_display_rv: {
            default: null,
        },
        accelerators: {
            default: null,
        },
        payments_rv: {
            default: null,
        },
    },
    data() {
        return {
            loading: 0,
            secondary_sellers: [],
            selected_seller: null,
            identification_seller: null,
            local_month: 1,
            local_year: 2023,
            advanceWorkingDays: 0,
            non_working_days: null,
            customColorWorkDays: '#12C2E9',

            currentDate: null,
            currentDay: null,
            currentMonth: null,
            currentYear: null,
            showRedDotRequest: 0
        }
    },
    mounted () {
        this.loadSecondarySellers()
        if(this.month === 404 || this.year === 404){
            let date = new Date();
            this.local_month = date.getMonth();
            this.local_year = date.getFullYear();
        }else{
            this.local_month = this.month
            this.local_year = this.year
        }
        this.non_working_days = this.getNonWorkingDays()

        this.currentDate = new Date();
        this.currentDay = this.currentDate.getDate();
        this.currentMonth = this.currentDate.getMonth() + 1;
        this.currentYear = this.currentDate.getFullYear();
        this.loadPDVsWithUsersHM();
    },
    watch: {
        currentDay: function() {
            this.calculateAdvance()
        },
        currentMonth: function() {
            this.calculateAdvance()
        },
        currentYear: function() {
            this.calculateAdvance()
        },
    },
    methods: {
        getNonWorkingDays() {
            axios.get(`/get-non-working-days`)
                 .then(({data}) => {
                     this.non_working_days = data.non_working_days
                     this.calculateAdvance()
                 })
        },
        isHoliday(dateToAnalyze) {
            // Se determina el dia, mes y año de la fecha a analizar
            const selectedDate = new Date(dateToAnalyze);
            const selectedDay = selectedDate.getDate();
            const selectedMonth = selectedDate.getMonth() + 1;
            const selectedYear = selectedDate.getFullYear();

            // Se determina si es dia no laborable personalizado
            if(this.non_working_days && this.non_working_days.length > 0) {
                if(this.non_working_days.includes(dateToAnalyze)) {
                    return true;
                }
            }

            // Se determina si es sábado o domingo
            const dayWeek = selectedDate.getDay();
            if(dayWeek === 0 || dayWeek === 6) {
                return true;
            }

            // Se determina si selectedDate pertenece a los dias festivos de fecha fija en Colombia
            if(
                (selectedDay === 1 && selectedMonth === 1) ||
                (selectedDay === 1 && selectedMonth === 5) ||
                (selectedDay === 20 && selectedMonth === 7) ||
                (selectedDay === 7 && selectedMonth === 8) ||
                (selectedDay === 8 && selectedMonth === 12) ||
                (selectedDay === 25 && selectedMonth === 12)
            ) {
                return true;
            }

            // Se determina si selectedDate es festivo de primer lunes
            const dayWeekSelectedDate = selectedDate.getDay();
            if(dayWeekSelectedDate === 1) {
                if(
                    (selectedDay === 6 && selectedMonth === 1) ||
                    (selectedDay === 19 && selectedMonth === 3) ||
                    (selectedDay === 29 && selectedMonth === 6) ||
                    (selectedDay === 15 && selectedMonth === 8) ||
                    (selectedDay === 12 && selectedMonth === 10) ||
                    (selectedDay === 1 && selectedMonth === 11) ||
                    (selectedDay === 11 && selectedMonth === 11)
                ) {
                    return true;
                } else {
                    for (let i = 6; i > 0; i--) {
                        const mlsDiff = i * 24 * 60 * 60000;
                        const mls = selectedDate.getTime();
                        const newSelectedDate = new Date(mls - mlsDiff);

                        const newSelectedDay = newSelectedDate.getDate();
                        const newSelectedMonth = newSelectedDate.getMonth() + 1;
                        const newSelectedYear = newSelectedDate.getFullYear();

                        if(
                            (newSelectedDay === 6 && newSelectedMonth === 1) ||
                            (newSelectedDay === 19 && newSelectedMonth === 3) ||
                            (newSelectedDay === 29 && newSelectedMonth === 6) ||
                            (newSelectedDay === 15 && newSelectedMonth === 8) ||
                            (newSelectedDay === 12 && newSelectedMonth === 10) ||
                            (newSelectedDay === 1 && newSelectedMonth === 11) ||
                            (newSelectedDay === 11 && newSelectedMonth === 11)
                        ) {
                            return true;
                        }
                    }
                }
            }

            // Se determina si selectedDate es festivo de pascua
            if(selectedMonth === 3 || selectedMonth === 4 || selectedMonth === 5 || selectedMonth === 6 || selectedMonth === 7) {
                let M = 0;
                let N = 0;
                if(selectedYear >= 1900 && selectedYear <= 2099) {
                    M = 24;
                    N = 5;
                } else if(selectedYear >= 2100 && selectedYear <= 2199) {
                    M = 24;
                    N = 6;
                } else if(selectedYear >= 2200 && selectedYear <= 2299) {
                    M = 25;
                    N = 0;
                }

                const a = selectedYear % 19;
                const b = selectedYear % 4;
                const c = selectedYear % 7;
                const d = ((19 * a) + M) % 30;
                const e = ((2 * b) + (4 * c) + (6 * d) + N) % 7;

                let diaPascua = 0;
                let mesPascua = 0;
                if((d + e) < 10) {
                    diaPascua = d + e + 22;
                    mesPascua = 3;
                } else if((d + e) >= 10) {
                    diaPascua = d + e - 9;
                    mesPascua = 4;

                    if(diaPascua === 26) {
                        diaPascua  = 19;
                    } else if((diaPascua === 25) && (d === 28) && (e === 6) && (a > 10)) {
                        diaPascua  = 18;
                    }
                }

                const domingoDePascua = new Date(selectedYear + "/" + mesPascua + "/" + diaPascua);
                const domingoDeRamos = new Date(domingoDePascua.getTime() - 604800000);
                const juevesSanto = new Date(domingoDePascua.getTime() - 259200000);
                const viernesSanto = new Date(domingoDePascua.getTime() - 172800000);
                const ascencion = new Date(domingoDePascua.getTime() + 3715200000);
                const corpus = new Date(domingoDePascua.getTime() + 5529600000);
                const sagradoCorazon = new Date(domingoDePascua.getTime() + 6134400000);

                if(
                    selectedDate.getTime() === domingoDePascua.getTime() ||
                    selectedDate.getTime() === domingoDeRamos.getTime() ||
                    selectedDate.getTime() === juevesSanto.getTime() ||
                    selectedDate.getTime() === viernesSanto.getTime() ||
                    selectedDate.getTime() === ascencion.getTime() ||
                    selectedDate.getTime() === corpus.getTime() ||
                    selectedDate.getTime() === sagradoCorazon.getTime()
                ) {
                    return true;
                }
            }
            return false;
        },
        calculateAdvance() {
            // Se determina el dia, mes y año en curso
            const currentDate = new Date(this.currentYear + '/' + this.currentMonth + '/' + this.currentDay);
            const currentDay = currentDate.getDate();
            const currentMonth = currentDate.getMonth() + 1;
            const currentYear = currentDate.getFullYear();

            // this.currentMonth = currentMonth;

            // Se determina la cantidad de dias del mes en curso
            const daysInCurrentMonth = new Date(currentYear, currentMonth, 0).getDate();

            let totalWorkingDays = 0;
            let currentWorkingDays = 0;
            let dayOfMonth = '';
            for (let i = 1; i <= daysInCurrentMonth; i++) {
                let isHoliday = false;   // false: Día hábil
                let digitDay;
                let digitMonth;

                // Se establece el dia a dos digitos
                digitDay = i < 10 ? `0${i}` : `${i}`;

                // Se establece el mes a dos digitos
                digitMonth = currentMonth < 10 ? `0${currentMonth}` : `${currentMonth}`;

                dayOfMonth = currentYear + '/' + digitMonth + '/' + digitDay;

                // const dayWeekend = (new Date(dayOfMonth)).getDay();
                isHoliday  = this.isHoliday(dayOfMonth);

                // if(isHoliday || dayWeekend === 0 || dayWeekend === 6) {
                if(!isHoliday) {
                    totalWorkingDays++;
                    if(i <= currentDay) {
                        // currentWorkingDays = totalWorkingDays;
                        currentWorkingDays++;
                    }
                }
            }

            this.advanceWorkingDays = currentWorkingDays / totalWorkingDays;
        },
        loadSecondarySellers(){
            this.loading++
            axios.get(`/get-secondary-sellers?identification=${this.identification}`)
                 .then(({data}) => {
                     this.secondary_sellers = data.secondary_sellers
                     this.loading--
                 })
        },
        changeSeller(){
            this.identification_seller = null
            setTimeout(() => {
                this.identification_seller = this.selected_seller
            }, 500);

        },
        loadPDVsWithUsersHM() {
            this.loading++;
            axios.get(`/get-pdvs-with-users-request?cache=1`)
                .then(({ data }) => {
                    this.showRedDotRequest = data.request_staff_count;
                    this.loading--;
                })
                .catch(error => {
                    console.error("Error al cargar los PDVs con usuarios:", error);
                    this.loading--;
            });
        },
    },
}
</script>
